/**
 * @generated SignedSource<<95769235708f56dfdb5b6849981dd65f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type PriorityCell$data = {
  readonly id: string;
  readonly lazyIsEditableInIssueView?: boolean | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"priority_issueFieldPriorityInlineEditFull_PriorityInlineEditViewIsEditable_fragmentRef">;
  readonly " $fragmentType": "PriorityCell";
};
export type PriorityCell$key = {
  readonly " $data"?: PriorityCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"PriorityCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "PriorityCell",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "condition": "isInlineEditingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "lazyIsEditableInIssueView"
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "priority_issueFieldPriorityInlineEditFull_PriorityInlineEditViewIsEditable_fragmentRef"
    }
  ],
  "type": "JiraPriorityField"
};

(node as any).hash = "848f61676a28ad11f73939af10dfe788";

export default node;
